import { tIssue } from "../data/Issues";
import { getBorderColor, getIssueIcon } from "../helper/HelperFunctions";
import './UnplannedIssueCard.css'; // Add this to import the styles

interface UnplannedIssueCardProps {
    issue: tIssue;
    onClickCallback: (issueId: number) => void;
}

export default function UnplannedIssueCard(props: UnplannedIssueCardProps) {
    // Destructure the issue object from props
    const { title, storyPoints, description, mainElement, type, epic } = props.issue;

    // Get the border color based on the mainElement
    const borderColor = getBorderColor(mainElement);

    return (
        <div className="card" style={{ borderColor }} onClick={() => props.onClickCallback(props.issue.id)}>
            <h3>{getIssueIcon(type)}{title}</h3>
            <p style={{marginBottom: '20px'}}>{description}</p>
            <div className="story-points">
                <span className="tooltip">Story Points</span>
                <p>{storyPoints}</p>
            </div>
            {/* Epic Tag */}
            <div className={`epic-tag epic-${epic.toLowerCase().replace(/\s+/g, '-')}`}>{epic}</div>
        </div>
    );
}
